import { ViewChild, EventEmitter, Input, Output, Component, AfterViewInit, AfterContentInit } from '@angular/core';
import { BaseUIEditableComponent } from './base-ui-editable.component';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { DateFormatPipe } from 'ngx-moment';


@Component({
  selector: 'DateChooser',
  template: `
    <mat-form-field [style.width]="width" [hidden]="!shouldShow">
      <input matInput [matDatepicker]="picker" [attr.placeholder]="NullDateLabel" #datePicker [(ngModel)]="innerValue"
             [ngClass]="className"
             (keydown)="handleKeyDownEvent($event)"
             tabIndex="{{TabIndexVal}}"
             (blur)="handleBlurEvent()"
             (focus)="handleFocusEvent()"
             style="height: inherit; margin: 0;"
             (dateChange)="handleCloseEvent($event)" (keyup.enter)="handleEnterKeyPressEvent($event)"
             [disabled]="readOnly.toLowerCase()=='true'"/>
      <mat-datepicker-toggle matSuffix [for]="picker"
                             [ngClass]="readOnly.toLowerCase()=='true'?'disablePointerEventClass':''"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <div class="datepicker-frame"></div>
  `,
  providers: [],
  styles: `
    :host {
      position: relative;
      flex-grow: 1;

      ::ng-deep .mat-mdc-form-field-infix {
        width: auto;
      }

      ::ng-deep mat-form-field {
        padding-top: 0;
        display: block;
      }

      .datepicker-frame {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 2px;
        pointer-events: none;
      }

      .mat-mdc-form-field-focus-overlay {
        display: none;
      }

      button.mat-mdc-icon-button.mat-mdc-button-base {
        padding: 0;
        width: 30px;
      }
    }



  `
})

// https://material.angular.io/guide/getting-started
export class DateChooserComponent extends BaseUIEditableComponent implements AfterViewInit, AfterContentInit {

  @ViewChild('datePicker', {static: true}) datePicker;

  @Output() AfterDateSelection: EventEmitter<void> = new EventEmitter();
  @Input() NullDateLabel = '(None)';
  @Input() width = '90px';
  @Input() dateTimectrlFlag = true;

  innerValue: Date | string;

  currentValue; // It is used to restore in case of invalid date entry.

  isKeyDownEventAllowed = false;
  textInDateBoxAsPerKeyDownFlow = '';
  classListToAppned = [];
  wasKeyPressed = false;
  componentType = 'DateChooser';
  shouldShow = true;

  private lastSelectedValue: Date | string;
  private pipe = new DateFormatPipe();

  constructor(private authService: AuthServiceCustom) {
    super();
  }

  get Value() {
    return this.pipe.transform(this.innerValue, 'MM/DD/YYYY');
  }

  set Value(arg) {
    if (arg !== this.datePicker.nativeElement.value && arg) {
      if (arg.toString().indexOf('T0') > 0) {
        arg = arg.split('T')[0] + 'T00:00:00';
      }
      // parseInt(arg.split("/")[2]) == 1
      if (new Date(arg).getFullYear() == 2001 && arg.toString().split('/').length > 2 && parseInt(arg.toString().split('/')[2]) == 1) {
        this.innerValue = null;
      } else if ((new Date(arg).getFullYear() == 1 || (new Date(arg).getFullYear() == 1901)) && new Date(arg).getMonth() == 0 && new Date(arg).getDate() == 1) {
        this.innerValue = null;
      } else {
        this.innerValue = new Date(arg);
      }
    } else if (!arg) {
      this.innerValue = arg;
    }
  }

  get element() {
    return this.datePicker.nativeElement;
  }

  ngAfterContentInit() {
    this.domEl = this.datePicker;
    this.determineClassNameForDOM();
  }

  ngAfterViewInit() {
    this.domEl = this.datePicker;
  }

  handleCloseEvent(event) {
    if (this.isValidDate(true)) {
      if (this.wasKeyPressed) {
        this.handleEnterKeyPressEvent(event, true);
      } else {
        this.emitSelectionIfChanged();
      }
    } else {
      this.Value = null;
    }
    this.isKeyDownEventAllowed = false;
    this.textInDateBoxAsPerKeyDownFlow = '';
    window.setTimeout(() => {
      this.datePicker.nativeElement.focus();
      let event;
      if (typeof (Event) === 'function') {
        event = new Event('keyup');
      } else {
        event = document.createEvent('Event');
        event.initEvent('keyup', true, true);
      }
      this.datePicker.nativeElement.dispatchEvent(event);
    });
  }

  isTextSelected(event) {
    let isAllSelected = false;
    if (typeof this.datePicker.nativeElement.selectionStart == 'number') {
      isAllSelected = this.datePicker.nativeElement.selectionStart == 0 && this.datePicker.nativeElement.selectionEnd == this.datePicker.nativeElement.value.length && this.datePicker.nativeElement.value.length > 0;
    }
    if (isAllSelected) {
      if (event.keyCode !== 9) {
        this.Value = null;
        window.setTimeout(() => {
          this.handleKeyDownEvent(event);
        });
      } else {
        isAllSelected = false;
      }
    }
    return isAllSelected;
  }

  handleKeyDownEvent(event: KeyboardEvent) {
    this.wasKeyPressed = false;
    const isTextSelected = this.isTextSelected(event);
    if (isTextSelected) {
      return false;
    }
    if (!this.datePicker.nativeElement.value || isTextSelected) {
      this.isKeyDownEventAllowed = true;
      this.textInDateBoxAsPerKeyDownFlow = this.datePicker.nativeElement.value;
    }

    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      if (this.isKeyDownEventAllowed && this.datePicker.nativeElement.value == this.textInDateBoxAsPerKeyDownFlow) {
        let valueOfDateBox: string = this.datePicker.nativeElement.value;
        if (!valueOfDateBox || isTextSelected) {
          valueOfDateBox = '';
        }
        valueOfDateBox += event.key;

        const dateParts = valueOfDateBox.split('/');

        let month = '';
        if (dateParts[0]) {
          month = dateParts[0];
        }

        let day = '';
        if (dateParts[1]) {
          day = dateParts[1];
        }
        let year = '';
        if (dateParts[2]) {
          year = dateParts[2];
        }

        if (!day && !year) {
          const firstDigitOfMonth = parseInt(month[0]);
          if (parseInt(month) > 12) {
            return false;
          }

          if ((firstDigitOfMonth <= 9 && firstDigitOfMonth > 1) || month.length == 2) {
            month += '/';
          }
        } else if (!year) {
          month += '/';
          const firstDigitOfDay = parseInt(day[0]);
          if (parseInt(day) > 31) {
            return false;
          }
          if ((firstDigitOfDay <= 9 && firstDigitOfDay > 3) || day.length == 2) {
            day += '/';
          }
        } else {
          month += '/';
          day += '/';
        }
        this.textInDateBoxAsPerKeyDownFlow = month + day + year;
        this.datePicker.nativeElement.value = this.textInDateBoxAsPerKeyDownFlow;
        return false;
      }
      // Check for month part
    } else if (event.keyCode == 191) {// '/'
      if (!this.datePicker.nativeElement.value) {
        return false;
      } else if (this.isKeyDownEventAllowed && this.datePicker.nativeElement.value == this.textInDateBoxAsPerKeyDownFlow && this.datePicker.nativeElement.value.endsWith('/')) {
        return false;
      } else {
        return true;
      }
    } else if (event.keyCode == 9) { // Tab
      return true;
    } else if (event.keyCode == 13) {
      this.wasKeyPressed = true;
      return true;
    } else if (event.keyCode != 13 // enter
      && event.keyCode != 8 && event.keyCode != 46 // Backspace & Delete
      && event.keyCode != 37 && event.keyCode != 39) {
      return false;
    }
  }

  handleBlurEvent() {
    if (!this.Value && this.datePicker.nativeElement.value) {
      this.isValidDate(false);
    }
    this.emitSelectionIfChanged();
  }

  handleFocusEvent() {
    try {
      this.datePicker.nativeElement.select();
    } catch (ex) {
    }
  }

  handleEnterKeyPressEvent(event: KeyboardEvent, isFromCloseEvent: boolean = false) {
    this.wasKeyPressed = false;
    if (!isFromCloseEvent && this.isValidDate(true)) {
      this.emitSelectionIfChanged();
    }
    this.isKeyDownEventAllowed = false;
    this.textInDateBoxAsPerKeyDownFlow = '';
  }

  determineClassNameForDOM() {
    // Handling Enabled Flag
    if ((this.enabled && this.enabled.toLowerCase() == 'false') || (this.readOnly && (this.readOnly.toLowerCase() == 'true'))) {
      // disbale the control
      this.isEnabled = false;
    } else {
      this.isEnabled = true;
    }

    // Handling Visible Flag
    if (this.visible && this.visible.toLowerCase() == 'false') {
      this.shouldShow = false;
    } else if (this.visible && this.visible.toLowerCase() == 'true') {
      this.shouldShow = true;
    }
    // Ends

    // Handling ReadOnly Flag
    if (this.readOnly && this.readOnly.toLowerCase() == 'true') {
      if (this.className != 'ChangedField') {
        this.className = 'DisplayField';
      }// this.appendAClass("DisplayField");
      // this.isReadOnly = true;
    } else if (!this.readOnly || this.readOnly.toLowerCase() == 'false') {
      // this.isReadOnly = false;
      if (this.Mandatory) {
        // this.appendAClass("EditableMandatoryField");
      } else {
        this.className = 'EditableField';
      }
    }
    if (this.width) {
      if (this.width.toLowerCase().indexOf('px') > 0) {
        this.datePicker.nativeElement.style['width'] = (parseInt(this.width) - 20) + 'px';
      } else if (this.width.indexOf('%') > 0 || this.width.toLowerCase().indexOf('px') > 0) {
        this.datePicker.nativeElement.style['width'] = 'calc(' + this.width + '-20px)';
      } else {
        this.datePicker.nativeElement.style['width'] = '80px';
      }
    }
  }

  isValidDate(showMsg = false) {
    let canBeValidDate = false;
    if (this.datePicker.nativeElement.value) {
      const dateParts = this.datePicker.nativeElement.value.split('/');
      if (dateParts.length == 3) {

        let year = dateParts[2] ? dateParts[2] : '';
        const yearsAllowed = (new Date().getFullYear() - 2000) * 2;

        if (year && year.length < 4 && parseInt(year) < 100) {
          if (parseInt(year) < yearsAllowed) {
            year = (2000 + parseInt(year)) + '';
          } else {
            year = (1900 + parseInt(year)) + '';
          }
        }

        if ((dateParts[0] && parseInt(dateParts[0]) > 0 && parseInt(dateParts[0]) <= 12)
          && (dateParts[1] && parseInt(dateParts[1]) > 0 && parseInt(dateParts[1]) <= 31)
          && (year && parseInt(year) >= 1900 && parseInt(year) <= (2000 + (yearsAllowed * 2)))) {
          // Valid Date
          // Check for leap year
          if (parseInt(dateParts[0]) == 2) {
            let maxDateAllowed = 28;
            if (year % 400 == 0) {
              maxDateAllowed = 29;
            } else if (year % 100 == 0) {
              maxDateAllowed = 28;
            } else if (year % 4 == 0) {
              maxDateAllowed = 29;
            }
            if (parseInt(dateParts[1]) <= maxDateAllowed) {
              canBeValidDate = true;
            }
          } else {
            canBeValidDate = true;
          }
          if (canBeValidDate) {
            this.innerValue = new Date(dateParts[0] + '/' + dateParts[1] + '/' + year);
            this.currentValue = dateParts[0] + '/' + dateParts[1] + '/' + year;
            showMsg = false;
          }
        }
      }
    }
    if (showMsg && this.datePicker.nativeElement.value) {
      return;
    }
    if (!canBeValidDate) {
      if (this.currentValue && this.datePicker.nativeElement.value) {
        this.datePicker.nativeElement.value = this.currentValue;
        this.Value = this.currentValue;
      } else {
        this.datePicker.nativeElement.value = '';
        this.Value = null;
      }
    }
    return canBeValidDate;
  }

  Focus() {
    this.focus();
  }

  focus() {
    window.setTimeout(() => this.datePicker.nativeElement.focus(), 0);
  }

  dateChooser_handleFocus() {
    this.datePicker.nativeElement.autocomplete = 'invalid';
  }

  private emitSelectionIfChanged() {
    const a = this.innerValue && (this.innerValue.valueOf && this.innerValue.valueOf() || this.innerValue);
    const b = this.lastSelectedValue && (this.lastSelectedValue.valueOf && this.lastSelectedValue.valueOf() || this.lastSelectedValue);
    if (a !== b) {
      this.AfterDateSelection.emit();
      this.lastSelectedValue = this.innerValue;
    }
  }
}
